import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { GenService } from '../../shared/gen-ser.service';

@Component({
  selector: 'date-scroller',
  templateUrl: './date-scroller.component.html',
  styleUrls: ['./date-scroller.component.css']
})
export class DateScrollerComponent implements OnChanges {
  
  @Input() selDate:Date;
  @Input() typeOfSel:typeOfDateSel = typeOfDateSel.Single_Date;
  @Output() dateChanged: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnChanges() {
  }

  getDateStr():string{
    if(this.selDate){
      if(this.typeOfSel == typeOfDateSel.Single_Date)
        return GenService.getDateFormatStr(this.selDate,"DD-MMM-YYYY");
      else if(this.typeOfSel == typeOfDateSel.Single_Month){
        var lastMonthDate = new Date(this.selDate);
        lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
        return GenService.getDateFormatStr(lastMonthDate,"") + " - " +
              GenService.getDateFormatStr(this.selDate,"");
      }
    }
    else{
      return "--------"
    }
  }

  PrevDateSel():void{
    if(this.typeOfSel == typeOfDateSel.Single_Date)
    {
      this.selDate.setDate(this.selDate.getDate() - 1);
    }
    else if(this.typeOfSel == typeOfDateSel.Single_Month)
    {
      this.selDate.setMonth(this.selDate.getMonth() - 1);
    }

    this.sendDateChangeNotification();
  }
  NextDateSel():void{
    if(this.typeOfSel == typeOfDateSel.Single_Date)
    {
      this.selDate.setDate(this.selDate.getDate() + 1);
    }
    else if(this.typeOfSel == typeOfDateSel.Single_Month)
    {
      this.selDate.setMonth(this.selDate.getMonth() + 1);
    }
    
    this.sendDateChangeNotification();
  }

  private sendDateChangeNotification():void{
    if(this.typeOfSel == typeOfDateSel.Single_Date)
      this.dateChanged.emit({'selDate':this.selDate});
    else if(this.typeOfSel == typeOfDateSel.Single_Month){
      var lastMonthDate = new Date(this.selDate);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      this.dateChanged.emit({'fromDate':lastMonthDate,'toDate':this.selDate});
    }
  }

}

enum typeOfDateSel{
  Single_Date = 0,
  Single_Month = 1
}